import { EntryPoint, TripType } from '../../models';
import { ABUtils, DateUtils } from '../../utils';

function getLocationValue(location, activeProduct) {
    if (!location) {
        return undefined;
    }
    if (location.geoNodeId !== 0) {
        return activeProduct === EntryPoint.TRAINS || !location.iata ? location.geoNodeId : location.iata;
    }
    return location.iata;
}

// GeoTypes returned by the geoRegion autocomplete (SE-3806). Legacy locations
// (top destinations, previous searches, geoNode autocomplete) carry a geoNode
// type such as CITY or AIRPORT instead: the dynpack funnel only resolves
// "<id>+<type>" for these two GeoTypes, so any other location keeps the legacy
// geoNodeId/iata value (SE-4102).
const GEO_REGION_TYPES = ['REGION', 'ACCOMMODATION'];

function getGeoRegionValue(destination) {
    return destination?.id && GEO_REGION_TYPES.includes(destination?.type)
        ? `${destination.id}+${destination.type}`
        : undefined;
}

function getDestinationValue(destination, activeProduct) {
    const { isDpGeoRegionAutocomplete } = ABUtils.getABs();
    if (activeProduct === EntryPoint.DP && isDpGeoRegionAutocomplete) {
        return getGeoRegionValue(destination) || destination?.geoRegion || destination?.geoNodeId || destination?.iata;
    }
    return getLocationValue(destination, activeProduct);
}

export const SegmentParams = {
    compose({ segments, tripType, activeProduct }) {
        const isMultiSegmentOneWay = tripType === TripType.ONE_WAY && segments.length > 1;
        const type = isMultiSegmentOneWay ? 'M' : tripType[0].toUpperCase();
        let url = `type=${type}`;

        if ( type!=='M' ) {
            const { origin, destination, date } = segments[0];
            const from = getLocationValue(origin, activeProduct);
            const toValue = getDestinationValue(destination, activeProduct);
            const to = toValue && destination.geoNodeId !== 0 ? `;to=${toValue}` : '';
            url += `;from=${from}${to};dep=${DateUtils.formatDate(date, 'yyyy-mm-dd')}`;

            if (tripType === TripType.ROUND_TRIP && segments[1]) {
                url += `;ret=${DateUtils.formatDate(segments[1].date, 'yyyy-mm-dd')}`;
            }
        } else {
            segments.forEach(({ origin, destination, date }, i) => {
                const from = getLocationValue(origin, activeProduct);
                const to = getDestinationValue(destination, activeProduct);
                url += `;from${i}=${from};to${i}=${to};dep${i}=${DateUtils.formatDate(date, 'yyyy-mm-dd')}`;
            });
        }
        return url;
    }
};
